'use strict';
var unitas = unitas || {};
const slider = document.querySelector('#js-popular-slider');
unitas.popularslider = unitas.popularslider || function () {
	function init() {
        if(slider) {
            var flkty = new Flickity( slider, {
                // options
                cellAlign: 'left',
                contain: true,
                pageDots: false,
                prevNextButtons: true,
                wrapAround: true,
                cellSelector: '.js-popular-slider-item'
            });
        }
	}
	return {
		init : init
	};
}();